import { jsx as _jsx } from "react/jsx-runtime";
import { memoGeneric } from '@/js/libs/memo/index.ts';
import { Loader } from '../../Elements/Loader/index.js';
import { NavigationItem } from './NavigationItem.js';
import { TabItem } from './TabItem.js';
export const TabsGroupContent = memoGeneric(function TabsGroupContent({ items, navigationItems, activeId, onChange, isLoading, }) {
    if (isLoading) {
        return _jsx(Loader, { height: 52 });
    }
    if (navigationItems) {
        return navigationItems.map((item) => _jsx(NavigationItem, { ...item }, item.to));
    }
    return items.map((item) => _jsx(TabItem, { item: item, active: item.id === activeId, onTabChange: onChange }, item.id));
});
